<template>
  <section class="ct-banner-columns">
    <div class="ct-banner-columns__container container">
      <div class="content-type__content">
        <div
          v-if="slice?.Settings?.Title"
          class="content-type__heading heading heading--2"
        >
          {{ slice.Settings.Title }}
        </div>

        <p
          v-if="slice?.Settings?.Description"
          class="content-type__description"
        >
          {{ slice.Settings.Description }}
        </p>

        <div
          class="ct-banner-columns__wrapper"
          :class="{ 'ct-banner-columns__wrapper-inverse': inverse }"
        >
          <div class="ct-banner-columns__single">
            <div class="ct-banner-columns__column ct-banner-columns__one">
              <StrapiBanner
                :banner="firstBanner"
                :lazy="true"
              />
            </div>
          </div>
          <div class="ct-banner-columns__multi">
            <div class="ct-banner-columns__column ct-banner-columns__two">
              <StrapiBanner
                :banner="secondBanner"
                :lazy="true"
              />
            </div>
            <div class="ct-banner-columns__column ct-banner-columns__three">
              <StrapiBanner
                :banner="thirdBanner"
                :lazy="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const props = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

const firstBanner = computed(() => props.slice?.Banners?.[0] ?? null)
const secondBanner = computed(() => props.slice?.Banners?.[1] ?? null)
const thirdBanner = computed(() => props.slice?.Banners?.[2] ?? null)
const inverse = computed(() => props.slice?.Inverse ?? false)
</script>

<style>
@import url("~layers/app/components/Slices/BannerColumns.css");
</style>
